/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { PencilIcon } from "@heroicons/react/solid";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "components/lib/Global/ReactTable";
import SearchInput from "components/lib/Shared/SearchInput";
import { getCompanyNameWithSuffix } from "utils/company";
import { getMaintainYourCompanyReviewStatus } from "config/documentData";
import EmptyTableState from "components/lib/Shared/EmptyTableState";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { useDebounce } from "use-debounce";
import { useHistory } from "react-router-dom";
import { getCompaniesTransactionsCorrectionsAsync } from "state/slices/companiesTransactions";

const ReviewApplicationCorrections = ({ setSelectedCompany = () => null }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounce(searchTerm, 1000);
  const {
    companiesTransactionsCorrections,
    getCompaniesTransactionsCorrections,
  } = useSelector((state) => state.companiesTransactionsSlice);

  useEffect(() => {
    dispatch(
      getCompaniesTransactionsCorrectionsAsync({
        queryParams: {
          limit: rowsPerPage,
          skip: (currentPage - 1) * rowsPerPage,
          search: debouncedSearchTerm,
          order: "desc",
        },
      })
    );
  }, [currentPage, debouncedSearchTerm, rowsPerPage]);

  const columns = [
    {
      Header: "Batch No.",
      accessor: "BatchNo",
      Cell: ({ row }) => row.original?.batchNo || "-",
    },
    {
      Header: "Name.",
      accessor: "companyName1",
      Cell: ({ row }) => {
        if (row.original?.companyInfo) {
          return getCompanyNameWithSuffix(row.original.companyInfo);
        } else {
          return getCompanyNameWithSuffix(row.original);
        }
      },
    },
    {
      Header: "Application Type",
      accessor: "applicationType",

      Cell: ({ row }) => {
        if (row.original?.applicationType) {
          return row.original?.applicationType;
        } else {
          if (row?.original?.transferYourBusinessInitiator) {
            return "Transfer Your Business";
          }
          return "Incorporation";
        }
      },
    },
    {
      Header: "Change Type",
      accessor: "changeType",
      Cell: ({ row: { original } }) => {
        const capitalize = (str) => {
          if (!str) return null;
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        return (
          capitalize(original?.changeType) || original?.companyInfo?.type || "-"
        );
      },
    },
    {
      Header: "Transaction Type",
      accessor: "transactionType",
      Cell: ({ row: { original } }) => {
        const capitalize = (str) => {
          if (!str) return null;
          let transactionType =
            str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
          return transactionType;
        };
        if (original?.transferYourBusinessInitiator) {
          return "Transfer Your Business";
        }

        return capitalize(original?.transactionType) || "Automatic";
      },
    },
    {
      Header: "Tnx No.",
      accessor: "TnxNo",
      Cell: ({ row: { original } }) => {
        return (
          original?.trxRef || original?.companyInfo?.registrationNumber || "-"
        );
      },
    },
    {
      Header: "Date",
      Cell: ({ row: { original } }) => {
        const date = original?.companyInfo?.createdAt || original?.createdAt;
        return date ? format(new Date(date), "yyyy/MM/dd") : "N/A";
      },
    },
    {
      Header: "Status",
      Cell: ({ row }) => {
        if (row.original?.applicationType) {
          return getMaintainYourCompanyReviewStatus(row.original?.status);
        } else {
          return row.original?.status || row.original?.status;
        }
      },
    },
    {
      Header: "Action",
      Cell: ({ row }) => {
        const handleReviewBtnClick = () => {
          if (row?.original?.trxRef) {
            history.push(
              `/companies/${row.original?.companyInfo?._id}/dashboard/transactions/${row.original._id}/recent-changes`
            );
          } else {
            history.push(`/companies/${row.original._id}`);
          }
        };
        return (
          <button onClick={handleReviewBtnClick} className="flex">
            <PencilIcon className="w-5 h-5 mr-2" aria-hidden="true" />
            Correct
          </button>
        );
      },
    },
  ];

  function handleSearch(event) {
    setSearchTerm(event.target.value);
  }

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between my-2">
        <div className="flex items-center space-x-4">
          <h2 className="font-semibold">Filter by:</h2>
        </div>
        <SearchInput value={searchTerm} handleOnChange={handleSearch} />
      </div>
      {companiesTransactionsCorrections.items.length > 0 ? (
        <div className="w-full bg-white shadow">
          <div className="w-full">
            <ReactTable
              columns={columns}
              data={companiesTransactionsCorrections.items}
              currentPage={currentPage}
              totalRows={companiesTransactionsCorrections.totalCount}
              rowsPerPage={rowsPerPage}
              setCurrentPage={setCurrentPage}
              paginate
              isLoading={
                getCompaniesTransactionsCorrections.status === "loading"
              }
            />
          </div>
        </div>
      ) : (
        <>
          {getCompaniesTransactionsCorrections.status === "loading" ? (
            <div className="z-10 flex items-center justify-center mt-10">
              <SpinnerIcon className="text-gray-400" />
            </div>
          ) : (
            <EmptyTableState>No companies</EmptyTableState>
          )}
        </>
      )}
    </div>
  );
};

export default ReviewApplicationCorrections;
